import { useEffect, useState } from '@wordpress/element';
import Button from '../../../../componentsNew/Button';
import Modal from '../../../../componentsNew/Modal';
import Typography from '../../../../componentsNew/Typography';
import { MdOutlineAccountCircle } from 'react-icons/md';
import { store } from '../../../../redux/store';
import { useSelect } from '@wordpress/data';
import {
  useDeleteObjetoGoogleApi,
  useGetContas,
  useGetPropriedades,
  useGetRefreshToken,
  useGetUrl,
  useUpdateGoogleApi,
} from '../../../../api/controllers/googleApi';
import { useAction, useActionParam } from '../../../../api/actions/action';
import { useGetTokenSincronizar } from '../../../../api/controllers/token';
import { URL_FRONT } from '../../../../api/services/axios';
import { toast } from 'react-toastify';
import Select from '../../../../componentsNew/Select';
import { IoMdAdd } from 'react-icons/io';
import { useContext } from '@wordpress/element';
import ContextSearch from '@pages/Dashboard/ContextSearch';

export default function ModalAnalytics({ valorInicial = false }) {
  const [open, setOpen] = useState(valorInicial);
  const [contaEscolhida, setContaEscolhida] = useState('');
  const [propriedadeEscolhida, setPropriedadeEscolhida] = useState('');

  const idBlog = useSelect(select => select(store).getBlogIdOpti());
  const idUsuario = useSelect(select => select(store).getUsuarioIdOpti());
  const { data: googleApi, refetch: refetchGoogleApi } = useGetRefreshToken(idBlog || 0);
  const [googleApiCheck, setGoogleApiCheck] = useState(googleApi ? true : false);
  const [isRedirect, setIsRedirect] = useState(false);
  const {
    data: contas,
    isSuccess: isSuccessContas,
    isLoading: isLoadingContas,
  } = useGetContas(googleApi?.refreshTokenAnalytics ? idBlog : 0);
  const {
    data: propriedades,
    mutateAsync: mutateAsyncPropriedade,
    isSuccess: isSuccessPropriedes,
    isLoading: isLoadingPropriedade,
  } = useGetPropriedades();
  const { data: url, mutateAsync: mutateAsyncUrl, isLoading: isLoadingUrl } = useGetUrl();
  const { mutate: mutateAction, data } = useAction();
  const { mutate: mutateCriarToken, data: token, isSuccess, isError } = useGetTokenSincronizar();
  const { mutate: mutateDelete, isSuccess: isSuccessDelete } = useDeleteObjetoGoogleApi();
  const { mutate: update, isLoading: isLoadingProp } = useUpdateGoogleApi();
  const { mutateAsync: mutateActionSalvar, isLoading: isLoadingPropWp } = useActionParam();
  const { dataPlanoUsuario } = useContext(ContextSearch);

  useEffect(() => {
    setGoogleApiCheck(googleApi ? true : false);
  }, [googleApi]);
  useEffect(() => {
    mutateAction('get_configuration_analytics');
  }, []);
  useEffect(() => {
    if (googleApi?.refreshTokenAnalytics && contaEscolhida && contaEscolhida != '')
      mutateAsyncPropriedade({ id: idBlog, conta: contaEscolhida });
  }, [contaEscolhida]);
  useEffect(() => {
    if (data && data?.data?.accountAnalytics && isSuccessContas) {
      if (contas?.accounts) setContaEscolhida(contas?.accounts[0].name);
      if (propriedades?.properties) setPropriedadeEscolhida(propriedades.properties[0].name);
      setContaEscolhida(data?.data?.accountAnalytics);
    }
    if (data && data?.data?.propertyAnalytics)
      setPropriedadeEscolhida(data?.data?.propertyAnalytics);
  }, [data, isSuccessContas]);

  useEffect(() => {
    if (token && isSuccess && isRedirect) {
      window.location.href =
        URL_FRONT +
        '/auth?token=' +
        encodeURIComponent(token?.token).toString() +
        '&redirect=' +
        encodeURIComponent(data?.data?.url_base) +
        '&origin=optimarketing';
    }
  }, [token]);

  useEffect(() => {
    if (isSuccessDelete && isRedirect) location.reload();
  }, [isSuccessDelete]);

  useEffect(() => {
    if (isError) {
      setIsRedirect(false);
      toast.error('Não foi possível carregar os dados para a sincronização do Google Analytics', {
        toastId: 'sync_analytics',
      });
    }
  }, [isError]);

  function openLoginGoogle() {
    if (googleApiCheck) {
      setIsRedirect(true);
      mutateDelete(idBlog);
      refetchGoogleApi();
    } else if (idUsuario != 0) {
      setIsRedirect(true);
      mutateCriarToken(idUsuario);
    } else {
      toast.error('Não foi possível carregar os dados para a sincronização do Google Analytics', {
        toastId: 'sync_analytics',
      });
    }
  }

  const handleClick = async prop => {
    //salvar propriedade analytics
    mutateAsyncUrl({ id: idBlog, conta: prop });

    if (
      googleApi &&
      googleApi.refreshTokenAnalytics &&
      prop &&
      prop != '' &&
      data?.data?.propertyAnalytics != prop
    ) {
      let g = googleApi;
      g.idAnalytics = prop.substring(prop.length - 9);
      g.refreshTokenAtivo = true;

      update(g);
      mutateActionSalvar({
        action: 'save_configuration_analytics',
        param: {
          account: contaEscolhida,
          property: prop,
        },
      });
    }
  };

  const opcoesCompletas = () => {
    const opcoes = (propriedades?.properties || []).map(item => ({
      onClickOpcao: () => handleClick(item.name),
      valor: item.name,
      titulo: item.displayName,
    }));

    return opcoes ?? [];
  };

  return (
    <div className="flex items-center">
      <Modal
        open={open}
        setOpen={setOpen}
        className="w-modal"
        titulo="Gerenciar Conta Google Analytics"
      >
        <div className="grid grid-cols-2 gap-12">
          <Typography component="body1-descricao" className="flex flex-col justify-items-start">
            A sua conta do Google Analytics permite que essa ferramenta monitore os acessos ao seu
            site, fornecendo informações sobre a qualidade do tráfego e outras informações úteis.
            <br />
            <br />
            Ao conceder acesso à sua conta, o plugin OPTI poderá obter os dados gerados pelo Google
            Analytics, utilizando-os para analisar os resultados de volume, tráfego, acessos e
            visualizações dos artigos. Além disso, o plugin poderá analisar o desempenho do seu site
            nos resultados de pesquisa (SERP), contribuindo para um melhor gerenciamento e
            desempenho do seu blog.
            <br />
            <br />
            <a
              className="font-bold text-info-main"
              target="_blank"
              href="https://www.opti.marketing/wordpress-plugin-plataforma-opti-marketing/"
            >
              Saiba mais.
            </a>
            <br />
          </Typography>
          <div className="flex flex-col justify-between">
            <>
              <div className="p-3 flex border-b-[1px] border-divider-medium items-center">
                {googleApiCheck ? (
                  <>
                    <img src={googleApi?.imagem} className="mr-3 h-7 w-7 rounded-full" />
                    <div className="flex flex-col">
                      <Typography component="body1" className="mb-2">
                        {googleApi?.nome}
                      </Typography>
                      <Typography component="body-card">{googleApi?.email}</Typography>
                    </div>
                  </>
                ) : (
                  <>
                    <MdOutlineAccountCircle className="mr-3 h-6 w-6 text-text-primary" />
                    <Typography>Conta Não Conectada</Typography>
                  </>
                )}
              </div>
              {googleApiCheck && (
                <div className="flex gap-4">
                  <Select
                    carregando={isLoadingContas || isLoadingUrl}
                    valorInput={contaEscolhida}
                    label="Conta"
                    setValorInput={setContaEscolhida}
                    opcoes={[].map.call(contas?.accounts || [], (item, index) => ({
                      valor: item.name,
                      titulo: item.displayName,
                    }))}
                  />
                  <Select
                    carregando={
                      isLoadingPropriedade || isLoadingUrl || isLoadingProp || isLoadingPropWp
                    }
                    valorInput={propriedadeEscolhida}
                    label="Propriedade"
                    setValorInput={setPropriedadeEscolhida}
                    opcoes={opcoesCompletas()}
                  />
                </div>
              )}
            </>
            <div className="flex flex-row gap-4 justify-end">
              {googleApiCheck ? (
                <>
                  <Button component="error" className="w-[50%]" onClick={() => openLoginGoogle()}>
                    Desconectar Analytics
                  </Button>
                </>
              ) : (
                <Button className="w-[50%]" onClick={() => openLoginGoogle()}>
                  Conectar Analytics
                </Button>
              )}
            </div>
          </div>
        </div>
      </Modal>

      {dataPlanoUsuario?.data?.pagamentoCorrespondeAoPeriodo && (
        <Button
          className="ml-3"
          onClick={() => {
            window.location.href = `${window.location.origin}/wp-admin/admin.php?page=optimarketing&criar-artigo=true`;
          }}
        >
          <IoMdAdd />
          Novo artigo
        </Button>
      )}
      <Button className="ml-3" onClick={() => setOpen(true)}>
        Gerenciar Conta Google Analytics
      </Button>
    </div>
  );
}
